<template>
  <div class="user-modal-wrapper">
    <div
      class="user-modal"
      :class="{ 'user-modal-small': limitedFunctionality }"
    >
      <form>
        <!-- USERNAME -->
        <div class="row">
          <div class="input-row-wrapper">
            <label for="userModalUsername" class="input-label"
              >Потребителско име</label
            >
            <div class="input-wrapper" :class="{ invalid: !isUsernameValid }">
              <span class="miv">B</span>
              <input
                id="userModalUsername"
                type="text"
                placeholder="Потребителско име"
                v-model="user.username"
                @keyup="(isUsernameValid = true), formatUsername()"
                :disabled="limitedFunctionality"
              />
              <span v-if="limitedFunctionality" class="disabled">A</span>
            </div>
          </div>

          <!-- NAME -->
          <div class="input-row-wrapper">
            <label for="userModalName" class="input-label">Име</label>
            <div class="input-wrapper" :class="{ invalid: !isNameValid }">
              <span class="miv">B</span>
              <input
                id="userModalName"
                type="text"
                placeholder="Име"
                v-model="user.name"
                @keyup="isNameValid = true"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <!-- EMAIL -->
          <div class="input-row-wrapper">
            <label for="userModalPhone" class="input-label">E-mail</label>
            <div class="input-wrapper" :class="{ invalid: !isEmailValid }">
              <span class="miv">B</span>
              <input
                id="userModalPhone"
                placeholder="E-mail"
                v-model="user.email"
                @keyup="isEmailValid = true"
              />
            </div>
          </div>
          <!-- PASSWORD -->
          <div class="input-row-wrapper">
            <label for="userModalPassword" class="input-label">Парола</label>
            <div class="input-wrapper" :class="{ invalid: !isPasswordValid }">
              <span class="miv">A</span>
              <input
                id="userModalPassword"
                type="password"
                placeholder="Парола"
                v-model="user.password"
                @keyup="isPasswordValid = true"
              />
            </div>
          </div>
          <!-- PHONE -->
          <div class="input-row-wrapper">
            <label for="userModalPhone" class="input-label">Телефон</label>
            <div class="input-wrapper">
              <span class="miv">B</span>
              <input
                id="userModalPhone"
                placeholder="Телефон"
                v-model="user.phone"
              />
            </div>
          </div>
        </div>
        <template v-if="!limitedFunctionality">
          <template v-if="getUser.permissions.isSuperAdmin">
            <hr />
            <div class="row">
              <!-- WAGE -->
              <div class="input-row-wrapper">
                <label for="userModalWage" class="input-label"
                  >Коефициент</label
                >
                <div class="input-wrapper">
                  <span class="miv">B</span>
                  <input
                    id="userCoefficient"
                    placeholder="Коефициент"
                    type="number"
                    v-model="user.coefficient"
                  />
                </div>
              </div>
              <!-- <div class="input-row-wrapper">
                <label for="userModalWage" class="input-label">Работна заплата</label>
                <div class="input-wrapper">
                  <span class="miv">B</span>
                  <input
                    id="userModalWage"
                    placeholder="Заплата (лв.)"
                    type="number"
                    v-model="user.wage"
                  />
                </div>
              </div> -->
              <!-- HOURLY RATE -->
              <!-- <div class="input-row-wrapper">
                <label for="userModalHourlyRate" class="input-label">Часова ставка (P3/22/8)</label>
                <div class="input-wrapper" :class="{ 'invalid': !isPasswordValid }">
                  <span class="miv">R</span>
                  <input
                    id="userModalHourlyRate"
                    placeholder="Часова ставка"
                    disabled
                    :value="`${ user.wage ? (user.wage / 22 / 8).toFixed(2) : 0 } лв/ч`"
                  />
                </div>
              </div> -->
            </div>
            <!-- COMMENT -->
            <label for="userModalComment" class="input-label">Коментар</label>
            <div class="input-wrapper">
              <span class="miv">Z</span>
              <input
                id="userModalComment"
                placeholder="Кратък коментар"
                type="text"
                v-model="user.comment"
              />
            </div>
            <hr />
          </template>
          <!-- PERMISSIONS -->
          <label class="input-label">Разрешения</label>
          <div class="user-modal-permissions">
            <label
              class="checkbox-wrapper"
              v-if="getUser.permissions.isSuperAdmin"
              title="Разрешението допълва правата на администратора. Изберете заедно с администратор"
            >
              Главен администратор
              <input type="checkbox" v-model="user.permissions.isSuperAdmin" />
              <span class="checkmark"></span>
            </label>
            <label class="checkbox-wrapper">
              Администратор
              <input type="checkbox" v-model="user.permissions.isAdmin" />
              <span class="checkmark"></span>
            </label>
            <label class="checkbox-wrapper">
              ЧР
              <input type="checkbox" v-model="user.permissions.isHR" />
              <span class="checkmark"></span>
            </label>
            <label class="checkbox-wrapper">
              Отчетник
              <input type="checkbox" v-model="user.permissions.isReporter" />
              <span class="checkmark"></span>
            </label>
            <label class="checkbox-wrapper">
              Работник
              <input type="checkbox" v-model="user.permissions.isWorker" />
              <span class="checkmark"></span>
            </label>
            <label class="checkbox-wrapper">
              Офис
              <input type="checkbox" v-model="user.permissions.isOfficeWorker" />
              <span class="checkmark"></span>
            </label>
          </div>
        </template>
        <!-- PAID LEAVE -->
        <template v-if="!limitedFunctionality && isAdmin">
          <hr />
          <label class="input-label">Платен отпуск</label>
          <div class="row">
            <div class="input-row-wrapper">
              <label for="userModalHiredAt" class="input-label"
                >Дата на постъпване</label
              >
              <div class="input-wrapper">
                <span class="miv">D</span>
                <input
                  id="userModalHiredAt"
                  type="date"
                  v-model="leave.hiredAt"
                />
              </div>
            </div>
            <template v-if="idToEdit && balance">
              <div class="input-row-wrapper">
                <label for="userModalLeaveYear" class="input-label"
                  >Година</label
                >
                <div class="input-wrapper">
                  <span class="miv">D</span>
                  <input
                    id="userModalLeaveYear"
                    type="number"
                    v-model.number="leave.year"
                    @change="getBalance()"
                  />
                </div>
              </div>
              <template v-if="balance.tracked">
                <div class="input-row-wrapper">
                  <label for="userModalLeaveAllowed" class="input-label"
                    >Разрешени дни</label
                  >
                  <div class="input-wrapper">
                    <span class="miv">Z</span>
                    <input
                      id="userModalLeaveAllowed"
                      type="number"
                      min="0"
                      step="0.5"
                      :placeholder="`Автоматично (${balance.allowedAuto})`"
                      v-model="leave.allowed"
                    />
                  </div>
                </div>
                <div class="input-row-wrapper">
                  <label for="userModalLeaveCarried" class="input-label"
                    >Пренесени дни</label
                  >
                  <div class="input-wrapper">
                    <span class="miv">Z</span>
                    <input
                      id="userModalLeaveCarried"
                      type="number"
                      step="0.5"
                      :placeholder="`Автоматично (${balance.carriedAuto})`"
                      v-model="leave.carried"
                    />
                  </div>
                </div>
              </template>
            </template>
          </div>
          <p class="leave-balance" v-if="idToEdit && balance">
            <template v-if="balance.tracked">
              {{ balance.year }} г.: разрешени
              <strong>{{ balance.allowed }}</strong> + пренесени
              <strong>{{ balance.carried }}</strong> =
              <strong>{{ balance.available }}</strong> дни · използвани
              <strong>{{ balance.used }}</strong>
              <template v-if="balance.pending">
                · чакащи <strong>{{ balance.pending }}</strong>
              </template>
              <template v-if="balance.expired">
                · изтекли <strong>{{ balance.expired }}</strong>
              </template>
              · остатък <strong>{{ balance.remaining }}</strong>
            </template>
            <template v-else>
              Балансът платен отпуск се следи от {{ balance.startYear }} г.
            </template>
          </p>
        </template>
        <div class="user-modal-actions">
          <div class="switch-container" v-if="!limitedFunctionality">
            <label class="switch">
              <input type="checkbox" v-model="user.isActive" />
              <span class="slider"></span>
            </label>
            <label v-if="user.isActive">Активен</label>
            <label v-else>Неактивен</label>
          </div>
          <div v-else>
            <!-- JUST AND EMPTY DIV FOR THE SPACE-BETWEEN RULE TO WORK -->
          </div>
          <div class="btns">
            <button class="btn btn-close" @click.prevent="closeModal(false)">
              <span class="miv">F</span>
              Отказ
            </button>
            <button
              v-if="!idToEdit"
              class="btn btn-new"
              type="submit"
              value="Submit"
              @click.prevent="register"
            >
              <span class="miv">B</span>
              Създай
            </button>
            <button
              v-else
              class="btn btn-new"
              type="submit"
              value="Submit"
              @click.prevent="edit"
            >
              <span class="miv">B</span>
              Редактирай
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { format } from "date-fns";
import log from "../mixins/log.js";
export default {
  mixins: [log],
  props: ["idToEdit", "limitedFunctionality"],
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      "getUser",
      // ...
    ]),
    isAdmin() {
      const p = this.getUser.permissions;
      return !!(p.isAdmin || p.isSuperAdmin);
    },
  },
  data() {
    return {
      isUsernameValid: true,
      isPasswordValid: true,
      isNameValid: true,
      isEmailValid: true,
      // paid leave balance for leave.year
      balance: undefined,
      // the edited hire date and the corrections for leave.year ("" = calculated)
      leave: {
        hiredAt: "",
        year: new Date().getFullYear(),
        allowed: "",
        carried: "",
      },
      // the leave as loaded - to save only when changed
      savedLeave: {},
      user: {
        username: "",
        password: "",
        email: "",
        name: "",
        isActive: true,
        phone: "",
        coefficient: 1,
        permissions: {
          isSuperAdmin: false,
          isAdmin: false,
          isReporter: false,
          isWorker: true,
          isHR: false,
          isOfficeWorker: false,
        },
      },
    };
  },
  methods: {
    getBalance(initial) {
      this.$http
        .get(
          `${process.env.VUE_APP_BASE_URI}/otpusk/balance/${this.idToEdit}?year=${this.leave.year}`
        )
        .then((response) => {
          const b = response.data;
          this.balance = b;

          // a changed hire date is kept when only the year is changed
          if (initial) {
            this.leave.hiredAt = b.hiredAt
              ? format(new Date(b.hiredAt), "yyyy-MM-dd")
              : "";
          }
          this.leave.allowed = b.tracked && b.allowedOverride !== null ? b.allowedOverride : "";
          this.leave.carried = b.tracked && b.carriedOverride !== null ? b.carriedOverride : "";

          this.savedLeave = Object.assign({}, this.leave, {
            hiredAt: initial ? this.leave.hiredAt : this.savedLeave.hiredAt,
          });
        })
        .catch((err) => console.log(err));
    },
    // saves the hire date and the corrections for the selected year, if changed
    saveLeave() {
      if (
        !this.isAdmin ||
        !this.balance ||
        JSON.stringify(this.leave) === JSON.stringify(this.savedLeave)
      ) {
        return Promise.resolve();
      }

      const body = { hiredAt: this.leave.hiredAt || null };

      if (this.balance.tracked) {
        Object.assign(body, {
          year: this.leave.year,
          allowed: this.leave.allowed,
          carried: this.leave.carried,
        });
      }

      return this.$http
        .put(
          `${process.env.VUE_APP_BASE_URI}/otpusk/balance/${this.idToEdit}`,
          body
        )
        .then(() => this.newLog("editPaidLeave", this.user.username));
    },
    getSpecificUser(id) {
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/auth/users/${id}`)
        .then((response) => {
          this.user = response.data;
        });
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    validateUsername(username) {
      if (!username.length) {
        return false;
      }
      const re = /^[a-z0-9_.-]*$/;
      if (!username.match(re)) {
        return false;
      }
      return true;
    },
    // Reformat username - only lowercase latin letters, numbers, dot, underscore and dash
    formatUsername() {
      this.user.username = this.user.username
        .replace(/[^A-Za-z0-9-._]/g, "")
        .toLowerCase();
    },
    checkForm() {
      if (!this.validateUsername(this.user.username)) {
        this.isUsernameValid = false;
      }
      if (!this.user.password && !this.idToEdit) {
        this.isPasswordValid = false;
      }
      if (!this.user.name) {
        this.isNameValid = false;
      }
      if (this.user.email) {
        if (this.user.email.length && !this.validateEmail(this.user.email)) {
          this.isEmailValid = false;
        }
      }
      // If everything is valid
      if (
        this.isUsernameValid &&
        this.isPasswordValid &&
        this.isNameValid &&
        this.isEmailValid
      ) {
        return true;
      }
      // if not
      return false;
    },
    register() {
      if (this.checkForm()) {
        let userForRequest = Object.assign({}, this.user, {
          hiredAt: (this.isAdmin && this.leave.hiredAt) || undefined,
        });
        // if (!userForRequest.email.length) {
        //   delete userForRequest.email;
        // }
        this.$http
          .post(`${process.env.VUE_APP_BASE_URI}/auth/register`, userForRequest)
          .then(() => {
            this.$snotify.success("Успешно регистрирахте нов потребител!");
            this.newLog("newUser", this.user.username);
            this.closeModal(true);
          })
          .catch((error) => {
            console.log(error.response);
            this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
          })
          .then(() => {});
      } else {
        // TODO: Do something
      }
    },
    edit() {
      if (this.checkForm()) {
        this.saveLeave()
          .then(() =>
            this.$http.put(
              `${process.env.VUE_APP_BASE_URI}/auth/users/${this.idToEdit}`,
              this.user
            )
          )
          .then((res) => {
            this.$snotify.success("Промените са записани успешно!");
            // IF THE CURRENTLY LOGGED USER CHANGED HIS OWN ROLE IT LOGGES HIM OUT
            if (this.idToEdit === this.$store.state.user._id) {
              const oldPermissions = this.$store.state.user.permissions;
              const newPermissions = res.data.user.permissions;
              if (
                !(
                  oldPermissions.isSuperAdmin === newPermissions.isSuperAdmin &&
                  oldPermissions.isAdmin === newPermissions.isAdmin &&
                  oldPermissions.isReporter === newPermissions.isReporter &&
                  oldPermissions.isWorker === newPermissions.isWorker &&
                  oldPermissions.isHR === newPermissions.isHR &&
                  oldPermissions.isOfficeWorker === newPermissions.isOfficeWorker &&
                  this.$store.state.user.isActive === res.data.user.isActive
                )
              ) {
                this.$store
                  .dispatch("logout")
                  .then(() => this.$router.push("/login"))
                  .catch((err) => console.log(err));
              }
            }
            this.newLog("editUser", this.user.username);
            this.closeModal(true);
          })
          .catch((error) => {
            console.log(error.response);
            this.$snotify.error(
              (error.response &&
                error.response.data &&
                error.response.data.failed) ||
                "Нещо се обърка! Моля опитайте отново."
            );
          })
          .then(() => {});
      } else {
        // TODO: Do something
      }
    },
    closeModal(isEdited) {
      // isEdited = true => means something is changed
      // isEdited = false => just close the modal
      this.$parent.$emit("closeUserModal", { isEdited: isEdited });
    },
  },
  mounted() {
    document.body.classList.add("stop-scrolling");
    if (this.idToEdit) {
      this.getSpecificUser(this.idToEdit);
      if (!this.limitedFunctionality && this.isAdmin) {
        this.getBalance(true);
      }
    }
    if (this.idToEdit === this.$store.state.user._id) {
      if (this.limitedFunctionality) {
        this.$snotify.warning(
          "Внимание! При редакция на профила ви ще бъдете разлогнати от системата и ще трябва да влезете отново."
        );
      } else {
        this.$snotify.warning(
          "Внимание! Ако промените някое от собствените ви разрешения или статус ще бъдете разлогнати от системата."
        );
      }
    }
  },
  destroyed() {
    document.body.classList.remove("stop-scrolling");
  },
};
</script>

<style scoped>
.user-modal-wrapper {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 2;
}
.user-modal {
  background-color: #fff;
  border-radius: 4px;
  border-top: 10px solid #083f75;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow: auto;
  padding: 10px 20px 0;
  width: 800px;
}
.user-modal-small {
  width: 600px;
}
.user-modal-permissions {
  background-color: #f4f4f4;
  border-radius: 4px;
  display: flex;
  justify-content: center;
}
.user-modal-actions {
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
}
.invalid .miv {
  color: #d91313;
}
.invalid input {
  background-color: #f8dcdc;
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.user-modal:not(.user-modal-small) .row {
  display: flex;
}
.user-modal:not(.user-modal-small) .input-row-wrapper {
  width: 100%;
}
.user-modal:not(.user-modal-small) .row .input-row-wrapper:not(:first-child) {
  margin-left: 20px;
}
.leave-balance {
  background-color: #f4f4f4;
  border-radius: 4px;
  line-height: 1.5;
  margin: 10px 0 0;
  padding: 10px;
}
hr {
  background-color: #f4f4f4;
  border: none;
  height: 1px;
  margin: 20px 0 10px;
}

/* Responsive */
@media screen and (max-width: 900px) {
  .user-modal {
    width: 90%;
  }
  .user-modal-permissions {
    flex-direction: column;
  }
}
@media screen and (max-width: 700px) {
  .user-modal.user-modal-small {
    width: 90%;
  }
}
@media screen and (max-width: 600px) {
  .user-modal-actions {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .switch-container {
    display: flex;
    justify-content: center;
    margin-bottom: 1em;
  }
  .row {
    flex-direction: column;
  }
  .user-modal:not(.user-modal-small) .row .input-row-wrapper:not(:first-child) {
    margin-left: 0;
  }
  .btns {
    justify-content: center;
  }
}
@media screen and (max-height: 550px) {
  .user-modal {
    height: 100%;
  }
  .user-modal.user-modal-small {
    height: 68%;
  }
}
@media screen and (max-height: 500px) {
  .user-modal.user-modal-small {
    height: 73%;
  }
}
@media screen and (max-height: 365px) {
  .user-modal.user-modal-small {
    height: 100%;
  }
}
</style>
